import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-sand py-11 sm:py-14" data-id="element-26" data-mp="187097aujeyf7">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-27" data-mp="13cml7ti7ftkk">
        <div className="text-center" data-id="element-28" data-mp="yf2v9wc59scs">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-3.5 py-1.5 font-display text-[0.62rem] font-bold uppercase tracking-editorial text-white" data-id="element-29" data-mp="ye1jfpnb11u0">
            <GiftIcon className="h-3 w-3" aria-hidden strokeWidth={2.5} data-id="element-30" data-mp="og58axuda6vw" />
            Incluidos gratis con tu compra
          </span>
          <h2 className="mt-3.5 font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-31" data-mp="kflea353bjdz">
            5 bonos de <span className="text-gold-deep" data-id="element-32" data-mp="2est23auneuq4">regalo</span>
          </h2>
        </div>

        <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="2eqqe0wd23bo1">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.04
        }} className="flex h-full items-start gap-3 rounded-xl bg-white px-3.5 py-3" data-id="element-34" data-mp="29s5devtw6pz2" data-mpi={i}>
              <span className="mt-0.5 flex h-6 shrink-0 items-center rounded-md bg-gold-soft px-2 font-display text-[0.6rem] font-bold uppercase tracking-[0.08em] text-gold-deep" data-id="element-35" data-mp="1ajdnmsxwcp8f">
                Bono {bono.num}
              </span>
              <div className="min-w-0" data-id="element-36" data-mp="10udmb2vx9hr2">
                <h3 className="font-display text-[0.83rem] font-bold leading-tight text-charcoal" data-id="element-37" data-mp="10tc1w7t0niwo">
                  {bono.name}
                </h3>
                <p className="mt-0.5 font-sans text-[0.75rem] leading-snug text-taupe" data-id="element-38" data-mp="1thzpwb55gmdx">{bono.role}</p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}